import React from "react";
// @mui
import { Link, Stack, Typography } from "@mui/material";
// routes
import { paths } from "src/routes/paths";
// components
import Button from "src/components/template/button";
import Image from "src/components/image";

// ----------------------------------------------------------------------

export default function NavDocs() {
    return (
        <Link
            target="_blank"
            rel="noopener"
            underline="none"
            href={ `${ paths.external.apiDoc }` }
            sx={{
                "@media (min-height:850px)": {
                    position: 'absolute', bottom: 0, width: '100%'
                },
                mt: "15px",
                }}
        >
        
            <Stack display="block" sx={ { width: 1, px: "15px", pb: "15px", mb: "5px" } }>
                <Stack alignItems="center" textAlign="center" spacing="11px" sx={ { p: "15px", backgroundColor: "#F4F4F4", borderRadius: "8px" } }>
                    <Stack spacing="10px">
                        <Stack direction="row" spacing="8px">
                            <Image src="/assets/icon/navbar/ic_bot.svg" alt="bot" width={ 38 } height={ 37 } objectFit="contain" disabledEffect visibleByDefault />

                            <Typography variant="body2" fontWeight={ 800 } color="text.primary" textAlign="left" textTransform="uppercase">
                                Need help with integration?
                            </Typography>
                        </Stack>

                        <Image src="/assets/image/system/news_2.svg" alt="news" objectFit="contain" disabledEffect visibleByDefault />

                        <Typography variant="caption" color="text.secondary">
                            Access our full API reference anytime.
                        </Typography>
                    </Stack>

                    <Button
                        variant="contained" layout="adapt" color="info" typographyProps={ { variant: "body2" } }
                        sx={ { height: 30, borderRadius: "25px" } }
                    >
                        API Docs
                    </Button>
                </Stack>
            </Stack>
        </Link>
    );
}
